// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"489":"d004c404","499":"e4b350a3","649":"ef4ffb6c"}[chunkId] + ".chunk.css";
};